export default __webpack_public_path__ + "static/media/LLL Section 2.00b474aa.png";